// import logo from './logo.svg';
import './App.css';
import Hero from './Hero';
import Navbar from './Navbar';
import About from './About';
import Skills from './Skills';
import Projects from './Projects';
import WorkEXperience from './WorkExperience';
import Jumbo from './Jumbo';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <About />
      <Skills />
      <WorkEXperience />
      <Jumbo/>
    </div>
  );
}

export default App;
